import { useEffect, useState } from 'react'
import { getSubmit } from 'ui-seeker/utils'

const CLOSED_PERIODS_URL = '/api/setting-report/closed-periods'

// Closed periods of some hotels + the business date to recommend (inverse of the union). One request each time the
// set of hotels changes (checked live); late answers for a previous set are ignored. No hotels -> null.
export default function useClosedPeriodsRecommendation(idHotelList) {
    const key = [...new Set((idHotelList || []).filter(Boolean).map(Number))].sort((a, b) => a - b).join(',')
    const [data, setData] = useState(null)

    useEffect(() => {
        let active = true
        if (!key) {
            setData(null)
            return
        }
        getSubmit(CLOSED_PERIODS_URL, { id_hotel: key })
            .then(res => active && setData(res))
            .catch(() => active && setData(null))
        return () => { active = false }
    }, [key])

    return data
}
